<div class="required-container">
	<div *ngIf="alertMessages$ | async as payload">
		<ng-container *ngIf="payload?.messages as messages; else legacyMessages">
			<div class="message-container" *ngFor="let message of messages" [class.message-container--success]="payload.type === 'success'">
				<flx-icon *ngIf="message" [type]="payload.type === 'success' ? 'check-circle-1' : 'alert'" [color]="payload.type === 'success' ? 'success' : 'alert'" [isClickable]="false"></flx-icon>
				<p>{{ message }}</p>
			</div>
		</ng-container>
		<ng-template #legacyMessages>
			<div class="message-container" *ngFor="let message of payload">
				<flx-icon *ngIf="message" [type]="'alert'" color="alert" [isClickable]="false"></flx-icon>
				<p>{{ message }}</p>
			</div>
		</ng-template>
	</div>
</div>
